import { render } from "./ListDataIzinSetuju.vue?vue&type=template&id=1e377b79"
import script from "./ListDataIzinSetuju.vue?vue&type=script&lang=js"
export * from "./ListDataIzinSetuju.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__